import { IMAGE_PLACEHOLDER, BASE_IMAGE_URL } from "@/constants/global";

export const extractExtension = (fileName = "") => {
  const file = fileName.split(".");
  file.pop();
  return file.join("");
};

interface ThumbnailImage {
  file?: string | string[];
  organizationId?: string;
  templateId?: string;
  size?: "150x150" | "800x500";
}

export const getThumbnailImage = ({ file, organizationId, templateId, size = "150x150" }: ThumbnailImage) => {
  if (!file || !file?.length || (!organizationId && !templateId)) {
    return IMAGE_PLACEHOLDER;
  }

  const draft = Array.isArray(file) ? file[0] : file;

  const fileName = extractExtension(draft).replaceAll(" ", "%20");

  if (templateId) {
    return `${BASE_IMAGE_URL}/images/templates/${templateId}/thumbs/${fileName}_${size}.webp`;
  }
  if (organizationId) {
    return `${BASE_IMAGE_URL}/images/organizations/${organizationId}/thumbs/${fileName}_${size}.webp`;
  }
};

export const getGalleryImage = (file: string, organizationId: string) => {
  const fileName = extractExtension(file);
  return `${BASE_IMAGE_URL}/images/organizations/${organizationId}/thumbs/${fileName}_800x500.webp`;
};
